import { render, staticRenderFns } from "./goodsdetails.vue?vue&type=template&id=3a5b76af&scoped=true"
import script from "./goodsdetails.vue?vue&type=script&lang=js"
export * from "./goodsdetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_b5e12a4b1c1729405afdf532a227c02e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5b76af",
  null
  
)

export default component.exports